import React, { useRef } from "react";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import "./employeeTooltip.css";
import infoIcon from "../../../../assets/SubscriptionImage/info_dark.png";

const EmployeeFaceTooltip = ({ imagePath }) => {
  const { getHost } = useApi();
  const containerRef = useRef(null);

  if (!imagePath) return null;

  const imageUrl = imagePath.startsWith("http")
    ? imagePath
    : `${getHost()}${imagePath}`;

  const handleMouseEnter = (e) => {
    const tooltip = e.currentTarget.querySelector('.emp-tooltip-image');
    const rect = e.currentTarget.getBoundingClientRect();
    
    tooltip.style.left = `${rect.left + rect.width / 2}px`;
    tooltip.style.top = `${rect.top}px`;
  };

  return (
    <div className="emp-tooltip-container" ref={containerRef} onMouseEnter={handleMouseEnter}>
      <img src={infoIcon} alt="info" className="emp-info-icon" />

      <div className="emp-tooltip-image">
        <img
          src={imageUrl}
          alt="Employee Face"
          loading="lazy"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      </div>
    </div>
  );
};

export default EmployeeFaceTooltip;
